import React from "react";
import TextInputModal from "../../../screens/Modals/TextInputModal";
import ExitConfirmationModal from "../../../screens/Modals/ExitConfirmationModal";
import InfoModal from "../../../screens/Modals/InfoModal";

const ModalManager = {
    openModal(type, idTask, setActiveModal, extra = {}) {
        console.log(">>> ModalManager.openModal props:", { type, idTask, extra });
        setActiveModal({ type, idTask, extraProps: extra });
    },

    renderModal(activeModal, setActiveModal) {
        if (!activeModal) return null;

        const commonProps = {
            onClose: () => setActiveModal(null),
            idTask: activeModal.idTask,
        };

        switch (activeModal.type) {
            case "textInput":
                return (
                    <TextInputModal
                        {...commonProps}
                        title={activeModal.extraProps?.title}
                        initialValue={activeModal.extraProps?.initialValue}
                        type={activeModal.extraProps?.type}
                        maxLength={parseInt(activeModal.extraProps?.maxLength ?? -1)}
                    />
                );

            case "exitConfirmation":
                return (
                    <ExitConfirmationModal
                        {...commonProps}
                    />
                );
            case "info":
                return (
                    <InfoModal/>
                );

            default:
                console.warn(`[ModalManager] Unknown modal type: ${activeModal.type}`);
                return null;
        }
    },
};

export default ModalManager;
